import { useImagePreviewUrl } from "../hooks/useImagePreviewUrl";
import { useSelectImage } from "../hooks/useSelectImage";
import type { ImageCandidate } from "../lib/api";

interface Props {
  draftId: string;
  candidates: ImageCandidate[];
  selectedImageId?: string;
}

export const ImageCandidateGrid = ({ draftId, candidates, selectedImageId }: Props) => {
  const select = useSelectImage();

  if (candidates.length === 0) return null;

  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
      {candidates.map((c) => (
        <Thumbnail
          key={c.id}
          draftId={draftId}
          candidate={c}
          selected={c.id === selectedImageId}
          onSelect={() =>
            select.mutate({
              draftId,
              candidateId: c.id === selectedImageId ? null : c.id,
            })
          }
        />
      ))}
    </div>
  );
};

interface ThumbnailProps {
  draftId: string;
  candidate: ImageCandidate;
  selected: boolean;
  onSelect: () => void;
}

const Thumbnail = ({ draftId, candidate, selected, onSelect }: ThumbnailProps) => {
  const { data, isLoading, isError } = useImagePreviewUrl(draftId, candidate.id);

  return (
    <button
      type="button"
      onClick={onSelect}
      className={`relative aspect-square overflow-hidden rounded-xl border-2 transition ${
        selected ? "border-blue-500 ring-2 ring-blue-400" : "border-slate-200 hover:border-slate-400"
      }`}
      title={candidate.prompt}
    >
      {isLoading && (
        <div className="flex h-full items-center justify-center text-xs text-slate-400">...</div>
      )}
      {isError && (
        <div className="flex h-full items-center justify-center text-xs text-red-500">erro</div>
      )}
      {data?.url && (
        <img
          src={data.url}
          alt={candidate.prompt.slice(0, 80)}
          className="h-full w-full object-cover"
          loading="lazy"
        />
      )}
      {selected && (
        <div className="absolute right-2 top-2 rounded-full bg-blue-500 px-2 py-0.5 text-xs font-semibold text-white">
          OK
        </div>
      )}
    </button>
  );
};
